type SomeOtherString = string & {};

export function pick<T extends object, S extends keyof T | SomeOtherString>(
  obj: T,
  ...properties: S[]
) {
  const newObj = {} as Pick<T, Extract<S, keyof T>>;
  for (const prop of properties) {
    if (prop in obj) {
      const key = prop as Extract<S, keyof T>;
      newObj[key] = obj[key];
    }
  }
  return newObj;
}

export function omit<T extends object, S extends keyof T | SomeOtherString>(
  obj: T,
  ...properties: S[]
) {
  const newObj = {} as {
    [K in keyof T]: K extends S ? never : T[K];
  };
  // Not using Omit<T, S & keyof T> here cause it completely
  // removes the keys from the type and this is note the desired behavior
  for (const prop in obj) {
    if (!properties.includes(prop as unknown as S)) {
      (newObj as Record<string, unknown>)[prop] = obj[prop];
    }
  }
  return newObj;
}
export function deepMerge<S, T extends Partial<S>>(a: S, b: T): S {
  const result: S = { ...a };
  for (const key in b) {
    if (b[key] === undefined) continue;
    // @ts-ignore
    if (!a[key]) a[key] = b[key];
    if (typeof b[key] === "object") {
      // @ts-ignore
      result[key] = deepMerge(a[key], b[key]);
    } else {
      // @ts-ignore
      result[key] = b[key];
    }
  }
  return result as S & T;
}
